import { render, staticRenderFns } from "./preview-privacy-image.vue?vue&type=template&id=07f86944&scoped=true"
import script from "./preview-privacy-image.vue?vue&type=script&lang=js"
export * from "./preview-privacy-image.vue?vue&type=script&lang=js"
import style0 from "./preview-privacy-image.vue?vue&type=style&index=0&id=07f86944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f86944",
  null
  
)

export default component.exports